/**
 * Users
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';

// Context
import AuthContext from '../../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getVariantAction,
  getCategoriesAction,
  getVariantInventoryItemsAction,
} from '../actions';
import {Store} from '../../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectVariant,
  makeSelectVariantFeaturesListByProductId,
  makeSelectCategoriesList,
  makeSelectCategoryLoading,
  makeSelectVariantInventoryItemsCount,
  makeSelectVariantInventoryItemsList,
} from '../selectors';

// Components
import List from './components/variantInventoryList';
import Edit from '../components/edit';
import Add from '../components/add';
import Details from '../components/variantDetail';
import Inventory from '../components/inventory';
import ReportList from './components/reportList';
import OrderList from '../../orders/mobileView/list';

// UI
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiKeyOutline,
  mdiFormatListBulleted,
  mdiArchiveOutline,
  mdiPencilOutline,
} from '@mdi/js';

// Helper
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';

// Type
import {Props, SelectorPropsVariant} from '../interfaces';
import Can from '../../../components/Can';
import useQuery from '../../../utils/hook/useQuery';
import classes from '../variant.module.scss';
import {GetInventoryFlowRequestBuilder} from 'client-sdk/src/skus/skus';
import OrdersRepository from 'client-sdk/src/Repository/orders-repository';
import Client from 'client-sdk/src/client';
import handleError from '../../../utils/handleError';
// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}
const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

const VariantMobile: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  const urlParams = useParams();
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);
  const [reportList, setReportList] = useState<any>(null);
  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [value, setValue] = useState(0);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [orders, setOrders] = useState([]);
  const token = localStorage.getItem('token') || '';

  useEffect(() => {
    getVariant();
    getVariantInventoryItems();
    fetchReportList(urlParams.variantId);
    getOrders();
  }, [filtersValues]);

  const getVariantInventoryItems = () => {
    const {page, size} = filtersValues;
    const variantId = urlParams.variantId;
    const warehouseId = urlParams.warehouseId;
    props.variantInventoryItemsDispatch({
      ...removeEmptyValueObject(filtersValues),
      skuId: {equals: variantId},
      warehouseId: {equals: warehouseId},
      status: {equals: 'LOCATED'},
      page,
      size,
    });
  };

  const fetchReportList = async (id: number, args?: Record<string, any>) => {
    try {
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    }
  };

  const getOrders = async () => {
    try {
      const {response} = await OrdersRepository.getOrders({
        payload: {
          'itemsSkuId.equals': urlParams.variantId,
          page: 0,
          size: 10,
        },
      });
      setOrders(response.data);
    } catch (err) {
      handleError(err.response);
    }
  };

  const getVariant = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.variantDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      id: urlParams.variantId,
      page,
      size,
    });
  };

  const handleDisableUser = async () => {
    const body = props.variantFeaturesList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: {...body, status: 'SUSPENDED'},
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabPanel = (props: any) => {
    const {children, value, index, ...other} = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Box className={classes.tabs}>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab
            style={{padding: '6px 5px'}}
            label="اطلاعات تنوع"
            {...a11yProps(0)}
          />
          <Tab
            style={{padding: '6px 5px'}}
            label="آیتم‌های انبار"
            {...a11yProps(1)}
          />
          <Tab
            style={{padding: '6px 5px'}}
            label="ورود و خروج"
            {...a11yProps(2)}
          />
          <Tab
            style={{padding: '6px 5px'}}
            label="سفارش‌ها"
            {...a11yProps(3)}
          />
        </Tabs>
      </Box>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <div className={classes.headerBox}>
          <Typography variant="h6" component="h2">
            {` جزئیات تنوع کالا`} {` `} {urlParams.variantId}
          </Typography>
        </div>
        <Link to={`/variant-edit/${urlParams.variantId}`}>
          <button
            aria-label="edit"
            size="small"
            title="ویرایش"
            data-cy="edit"
            className={classes.editBtn}
          >
            <Icon path={mdiPencilOutline} size={1} />
          </button>
        </Link>
      </Grid>
      <TabPanel value={value} index={0}>
        <Details variant={props.variant} />
        <Card className={classes.card} style={{marginTop: '18px'}}>
          <CardHeader
            avatar={
              <Typography className={classes.typographyCards}>
                ویژگی‌های تنوع کالا
              </Typography>
            }
          />

          <CardContent style={{margin: '15px 0  0', padding: '20px'}}>
            <Grid container item>
              {props.variantFeaturesList?.map((field, index) => {
                return (
                  <Grid item xs={12} sm={12} lg={12}>
                    <div className={classes.item}>
                      <span className={classes.label}>{field.key}</span>
                      <span>{field.value}</span>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </CardContent>
        </Card>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Card className={classes.cardMob}>
          <CardContent style={{margin: '15px 0  0', padding: '0'}}>
            <Grid spacing={3} container>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                props.productVariantInventoryItemsList && (
                  <List
                    data={props.productVariantInventoryItemsList}
                    handleOpenConfirmDisable={handleOpenConfirmDisable}
                    handleOpen={handleOpen}
                    changeStatus={handleOpenConfirmUpdateState}
                  />
                )
              )}
            </Grid>
          </CardContent>
        </Card>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Card className={classes.cardMob}>
          <CardContent style={{margin: '15px 0  0', padding: '0'}}>
            <Grid spacing={3} container>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                reportList?.content && (
                  <ReportList data={reportList?.content} handleSelect={null} />
                )
              )}
            </Grid>
          </CardContent>
        </Card>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Card className={classes.cardMob}>
          <CardContent style={{margin: '15px 0  0', padding: '0'}}>
            <Grid spacing={3} container>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                orders && (
                  <OrderList
                    data={orders}
                    // handleConfirmCanceleBox={handleOpenConfirmCancele}
                    // changeStatusOrderWhitId={changeStatusOrderWhitId}
                    handleOpenConfirmUpdateState={handleOpenConfirmUpdateState}
                  />
                )
              )}
            </Grid>
          </CardContent>
        </Card>
      </TabPanel>
      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${props.variantFeaturesList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {`بله`}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${props.variantFeaturesList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.variantFeaturesList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.variantFeaturesList.find(
                product => product.id === id
              )}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorPropsVariant>({
  variant: makeSelectVariant(),
  categoriesList: makeSelectCategoriesList(),
  variantFeaturesList: makeSelectVariantFeaturesListByProductId(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  categoryLoading: makeSelectCategoryLoading(),
  error: makeSelectError(),
  productVariantInventoryItemsList: makeSelectVariantInventoryItemsList(),
  productVariantInventoryItemsListCount: makeSelectVariantInventoryItemsCount(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    variantDispatch: (payload: Object) => dispatch(getVariantAction(payload)),
    categoriesDispatch: (payload: Object) =>
      dispatch(getCategoriesAction(payload)),
    variantInventoryItemsDispatch: (payload: Object) =>
      dispatch(getVariantInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(VariantMobile);
